import * as ResourceApi from 'api/resources';
import * as ServiceApi from 'api/services';

export const validateBreak = (challengeId, platforms) => ServiceApi.performAction(
  ResourceApi.Types.PublishedBreak, // FIXME: is this right? or should it just be ResourceApi.Types.Break?
  ServiceApi.Actions.ValidateBreak,
  {
    challengeId,
    platforms,
    publish: false
  }
);

export const publishBreak = (challengeId, platforms) => ServiceApi.performAction(
  ResourceApi.Types.PublishedBreak,
  ServiceApi.Actions.PublishBreak,
  {
    challengeId,
    platforms,
    publish: true
  }
);

export const unpublishBreak = (challengeId, platforms) => ServiceApi.performAction(
  ResourceApi.Types.PublishedBreak,
  ServiceApi.Actions.UnpublishBreak,
  {
    challengeId,
    platforms,
    publish: false // FIXME: is this right? or is it even needed?
  }
);



// WEBPACK FOOTER //
// ./public/api/break-service.js